import React from "react";
import icon from "./icon.svg";

function RemoveIcon({ className }: { className?: string }) {
  return <img src={icon} className={className} alt="" />;
}

export { RemoveIcon };
